import { GridColDef } from "@mui/x-data-grid";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";
import { TrailerType } from "../../Fleet/TrailerType";
import { camelCaseToSentenceCase } from "../../../helpers/camelCaseToSentenceCase";

const formatTrailerType = (value: string | null | undefined) => {
  if (!value) return "—";

  return (
    TrailerType.find(
      (trailerType) => trailerType.value.toLowerCase() === value.toLowerCase(),
    )?.label ?? camelCaseToSentenceCase(value)
  );
};

export const trailersTableColumns: GridColDef[] = [
  { field: "unitNumber", headerName: "Unit Number", width: 250 },
  { field: "vin", headerName: "VIN", width: 300 },
  { field: "make", headerName: "Make", width: 300 },
  { field: "model", headerName: "Model", width: 250 },
  { field: "year", headerName: "Year", width: 100 },
  {
    field: "trailerType",
    headerName: "Trailer Type",
    width: 180,
    valueFormatter: formatTrailerType,
  },
  { field: "status", headerName: "Status", width: 150 },
  { field: "transactionType", headerName: "Transaction Type", width: 200 },
  {
    field: "delete",
    headerName: "",
    width: 130,
    renderCell: (params) =>
      params.row.isActive ? (
        <ConfirmActionButton
          id={params.row.id}
          entityType="Trailer"
          actionType="delete"
          entityLabel="trailer"
          queryKey="trailersTable"
          buttonLabel="Delete"
          buttonColor="error"
        />
      ) : (
        <ConfirmActionButton
          id={params.row.id}
          entityType="Trailer"
          actionType="restore"
          entityLabel="trailer"
          queryKey="trailersTable"
          buttonLabel="Restore"
          buttonColor="success"
        />
      ),
  },
];
